import RaceXLogo from '../../../assets/images/racex_logo.png';
import RaceXIcon from '../../../assets/images/racex.png'
import './TokenInfo.css';

const TokenInfo = () => {
  return (
    <div className='tokenInfo' id='racexToken'>
      <img src={RaceXLogo} className='tokenInfo__racexLogo' alt='racex logo'/>
      <label className='home__subtitle' style={{display:'flex'}}>
        ABOUT THE RACEX TOKEN
        <img src={RaceXIcon} width='48x' height='48px' style={{marginLeft:'10px'}} alt='logo'/>
      </label>
      <label className='home__subtext2'>
        RaceX is the governance and utility token of DCRC - Race2Earn gaming.
      </label>

      <div className='tokenInfo__box'>
        <h2>RaceX tokenomics</h2>
        <div className='tokenInfo__part__box'>
          <div className='tokenInfo__part'>
            <div className='tokenInfo__subpart'>
              <label className='tokenInfo__subtitle'>Max supply</label>
              <label>1.000.000.000 RaceX</label>
            </div>
            <div className='tokenInfo__subpart'>
              <label className='tokenInfo__subtitle'>Circulating supply</label>
              <label>750.000.000</label>
            </div>
            <div className='tokenInfo__subpart'>
              <label className='tokenInfo__subtitle'>Project supply</label>
              <label>
                300.000.000<br/>
                &nbsp;&nbsp;70% Liquidity<br/>
                &nbsp;&nbsp;15% Team<br/>
                &nbsp;&nbsp;10% Staking Rewards<br/>
                &nbsp;&nbsp;5% Marketing<br/>
              </label>
            </div>
          </div>
          <div className='tokenInfo__part'>
            <label className='tokenInfo__subtitle'>Token fair launched</label>
            <label>
              Our token was fair launched on October 17th 2021. 15% of the supply (team distribution) has been locked for 1 year total with monthly unlocks: <a href="https://team.finance/view-coin/0x7086e045b78E1e72F741F25231c08d238812CF8a?name=RaceX&symbol=RACEX"  target="_blank"> Team  Locks</a>
              <br/>All original liquidity is locked for 6 months: <a href="https://cchain.explorer.avax.network/tx/0xfd9556b78ef5e6e29c92a22b5bc08ce2578728ee8f3630db076edbc0eedab45f/token-transfers"  target="_blank"> Liquidity Locks</a>
            </label>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TokenInfo;